import copy from 'copy-to-clipboard';
import { useCallback } from 'react';

export const useCopyToClipboard = () => {
  const onCopy = useCallback((text: Parameters<typeof copy>[0], options?: Parameters<typeof copy>[1]) => {
    return copy(text, options);
  }, []);

  return onCopy;
};

export const useCopyMarkdownToClipboard = () => {
  const copyMarkdown = useCallback(async (markdownText: string, htmlContent?: string): Promise<boolean> => {
    try {
      // Check if the modern Clipboard API is available and we have HTML content
      if (navigator.clipboard && navigator.clipboard.write && htmlContent) {
        // Create clipboard items with both text and HTML formats
        const clipboardItem = new ClipboardItem({
          'text/plain': new Blob([markdownText], { type: 'text/plain' }),
          'text/html': new Blob([htmlContent], { type: 'text/html' }),
        });

        await navigator.clipboard.write([clipboardItem]);
        return true;
      } else {
        // Fallback to the old copy-to-clipboard library
        return copy(markdownText);
      }
    } catch (error) {
      console.warn('Failed to copy with formatting, falling back to plain text:', error);
      // Fallback to plain text copy
      return copy(markdownText);
    }
  }, []);

  return copyMarkdown;
};
